// Copyright 2020 Cartesi Pte. Ltd.
export const loadTurrets = () => {
    return require('./resources/turrets.json');
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHVycmV0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R1cnJldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxtQ0FBbUM7QUFjbkMsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLEdBQXFDLEVBQUU7SUFDOUQsT0FBTyxPQUFPLENBQUMsMEJBQTBCLENBQUMsQ0FBQztBQUMvQyxDQUFDLENBQUMifQ==